module.exports = __webpack_public_path__ + "img/close.e90175bc.svg";